<template>
    <div class="">
        <div class="text-sm leading-5 text-gray-900">
            {{ area }}
        </div>
        <div class="text-sm leading-5 text-gray-500">
            {{ zone }}
        </div>
        <div class="text-sm leading-5 text-gray-500">
            {{ location }}
        </div>'
    </div>

</template>

<script>
    export default {
        name: "MeterLocationView",
        props: ['areaName', 'zoneName', 'locationName'],
        data: () => {
            return {
                area: this.areaName,
                zone: this.zoneName,
                location: this.locationName,
            }
        },
    }
</script>

<style scoped>

</style>